export default "__VITE_ASSET__CJ11b0tl__"